import { c as _c } from "react/compiler-runtime";
import { Box, type BoxProps } from '@mui/material';
import React from 'react';
import { StructuredContentRenderer } from 'src/features/content/StructuredContentRenderer';
import { useCompareContext } from '../Context';
const BelowSections = props => {
  const $ = _c(5);
  const {
    compareData: t0
  } = useCompareContext();
  const {
    belowSectionsContent
  } = t0;
  let t1;
  if ($[0] !== belowSectionsContent) {
    t1 = <StructuredContentRenderer doc={belowSectionsContent} />;
    $[0] = belowSectionsContent;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== props || $[3] !== t1) {
    t2 = <Box {...props}>{t1}</Box>;
    $[2] = props;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
};
export default BelowSections;